<template>
  <div>
    <panel background-color="#fffee0" style="text-align: center; border: 1px solid #000;">
      Price shown includes transportation fee to bring parcel across the border.<br />
      Delivery dates based on shipment being dropped off at <a href="https://goo.gl/maps/MKFW6YSMMNv4odpj6">our warehouse</a> <br>
      <strong>before 10:00 am Mon-Fri</strong>
    </panel>

    <div style="border: 1px solid #ebebeb; border-radius: 4px; padding: 16px 24px">
      <h4 style="line-height: 0">Payment Details</h4>
      <credit-card
          :total="total"
          :currency="currency"
          :client-secret="clientSecret"
          :return-url="returnUrl"
          v-on="$listeners"
      ></credit-card>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {
    clientSecret: String,
    returnUrl: String,
    currency: String,
    total: Number,
  },
  data: () => ({
  }),
  methods: {
  },
}
</script>
